module.exports = __webpack_public_path__ + "img/sales.83bd1dcc.svg";